import axios from 'axios'
import { openNewTabBlobFile } from 'utils/helper'

export const getProformaInvoice = (id, params) => {
  return axios.get(`/finance/proformas/${id}`, { params })
}

export const addProformaInvoice = (data) => {
  return axios.post(`/finance/proformas`, data)
}

export const editProformaInvoice = (data) => {
  return axios.put(`/finance/proformas/${data.id}`, data)
}

export const deleteProformaInvoice = (id) => {
  return axios.delete(`/finance/proformas/${id}`)
}

export const deleteOnAddProformaInvoiceAttachment = (url) => {
  return axios.delete('/finance/proformas/attachments', { data: { url } })
}

export const deleteOnEditProformaInvoiceAttachment = (id, url) => {
  return axios.delete(`/finance/proformas/${id}/attachments`, { data: { url } })
}

export const createPdfProformaInvoice = (id) => {
  return axios
    .get(`/finance/proformas/${id}/print`, { responseType: 'blob' })
    .then((response) => {
      openNewTabBlobFile(response.data)
      return Promise.resolve(true)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export const getProformaInvoiceEmailTemplate = (id) => {
  return axios.get(`/finance/proformas/${id}/email`)
}

export const sendProformaInvoiceEmail = (id, data) => {
  return axios.post(`/finance/proformas/${id}/email`, data)
}

export const getProformaInvoicePublicUrl = (id) => {
  return axios.get(`/finance/proformas/${id}/publicUrl`)
}

export const getProformaInvoiceLog = ({ id, params } = {}) => {
  return axios.get(`/finance/proformas/${id}/logs`, { params })
}
